export default __webpack_public_path__ + "static/media/aws.1e75ae67.png";